// src/components/Widget.js
import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Widget = ({ title, actions, children }) => {
  const theme = useTheme();
  return (
    <Paper elevation={3} sx={{ padding: 2, height: '100%', width: '100%', bgcolor: theme.palette.mode === "dark" ? "rgb(16, 16, 16)" : "background.default", }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
          
          backgroundImage: "none"
        }}
      >
        <Typography variant="h6">{title}</Typography>
        {actions && <Box sx={{ display: 'flex', gap: 1 }}>{actions}</Box>}
      </Box>
      <Box sx={{ height: 'calc(100% - 40px)' }}>{children}</Box>
    </Paper>
  );
};

export default Widget;
